import React, { useEffect } from 'react'
import { useForm } from "react-hook-form";
import D3 from "../../Docs/ABCUserData.xlsx";
import { closeRemoveModal } from "../../redux/actions/modalActions"
import swal from 'sweetalert';
import * as utilities from "../../utilities/utils";
import UploadSvg from "../../images/upload.svg";
import moment from "moment"
import { PREFERED_LANGUAGE_KEYS } from '../../App.config';

const UploadUserModalComponent = (props) => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    useEffect(() => {
        return () => {
            props.resetFileHistory();
        };
    }, []);

    const handleFileUpload = (event) => {
        if (!event.target.files.length)
            return;
        let Vfiles = event.target.files
        let filename = Vfiles[0].name
        let result = filename.match("^.+\.(xlsx)$")
        if (result == null) {
            // alert("Filename Must Be xlsx");
            swal("Please upload an XLSX file only (Excel File)");
        }
        else {
            let { files } = event.target;
            let formData = new FormData();
            if (files[0]) {
                formData.append("file", files[0]);
                formData.append("companyId", props.selectedCompany);
                formData.append("authToken", utilities.getTokenHeader().authToken);
                formData.append("isLangEng", props.in18Reducer.lang === PREFERED_LANGUAGE_KEYS.EnglishUS
                ? true
                : false,);
                props.uploadFileForUserData(formData);
                props.closeRemoveModal();
            }
        }

        event.target.value = ''
    }

    return (
        <>
            <div className="modal-dialog modal-dialog-centered z-index-999" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        Import Users
                         {/* <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => props.closeRemoveModal()}
                        >
                            
                            <span aria-hidden="true">&times;</span>
                        </button> */}
                    </div>
                    <div className="modal-body">
                        <form
                            onSubmit={handleSubmit(handleFileUpload)}
                        >
                            {/* <div className="form-group">
                                <label className="text-label">Enter OTP<span className="star-error">*</span></label>
                                <input
                                    type="text"
                                    name="OTP"
                                    className="form-control"
                                    placeholder="Enter OTP"
                                    {...register("OTP", { required: true })}
                                />
                                      <small className="text-danger">{errors.OTP && <p>{errors.OTP.message}</p>}</small>
                            </div>
                            <small className="text-danger">{errors.OTP?.type === 'required' && "OTP is required"}</small>
                            <div className="text-right">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value="Submit"
                                />
                            </div> */}
                            <div className="">
                                <label>Upload Userdata(<a href={D3} download={D3.xlsx}>Sample File</a>)<br/>(FULL HR: 4XV2GK , LIMITED CAL HR:S0GLM4 , MANAGER : FOSDSM )</label>
                                <div className="form-group">
                                    <div className="upload-btn-wrapper form-control">
                                        <button tabIndex="-1" className="upload-btn">
                                            <img tabIndex="-1" src={UploadSvg} alt="" />
                                            {props.context.t(
                                                "STD-Employer-Statement.form.Employer-Details.label.text.Upload"
                                            )}

                                        </button>
                                        <input
                                            onChange={handleFileUpload}
                                            type="file"
                                            tabIndex="-1"
                                            name="attachment"
                                        />
                                    </div>

                                </div>
                            </div>
                        </form>
                        {Array.isArray(props.fileHistory) && props.fileHistory.length == 0 ? <span className="mr-2">
                            <button className="file-upload mt-0 btn btn-primary"
                                onClick={() => props.getFileHistory(3)}
                            >File History</button>
                        </span> :
                            <span className="mr-2">
                                <button className="file-upload mt-0 btn btn-primary"
                                    onClick={() => props.resetFileHistory()}
                                >Hide</button></span>}
                        {Array.isArray(props.fileHistory) && props.fileHistory.length > 0 &&
                            <table class="table mt-2">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">File Name</th>
                                        <th scope="col">Uploaded By</th>
                                        <th scope="col">Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(props.fileHistory) && props.fileHistory.map((fileHistory, i) => {
                                        return (
                                            <tr>
                                                <th scope="row">{i + 1}</th>
                                                <td><a title={fileHistory.FileName}>{fileHistory.FileName.length<=10?fileHistory.FileName:fileHistory.FileName.slice(0,10) + "..."}</a></td>
                                                <td><a title={fileHistory.FirstName + " " + fileHistory.LastName}>{(fileHistory.FirstName.length + 1 + fileHistory.LastName.length)<=10?fileHistory.FirstName + " " + fileHistory.LastName:fileHistory.FirstName + " " + fileHistory.LastName + "..."}</a></td>
                                                <td><a title={moment(fileHistory.CreatedOnDate).format("MMM DD YYYY")}>{moment(fileHistory.CreatedOnDate).format("MMM DD YYYY")}</a></td>
                                            </tr>
                                        )

                                    })}


                                </tbody>
                            </table>
                        }

                    </div>
                </div >
            </div >
        </>
    );
};
export default UploadUserModalComponent;
